














import Vue from 'vue'

export default Vue.extend({
  mounted() {
    console.log("Tags mounted",
    (this as any).params)
  },
  computed: {
    tags() {
      if ((this as any).params && (this as any).params.valueFormatted) {
        return (this as any).params.valueFormatted;
      }

      return [];
    }
  },
})
